import { useEffect, useState } from "react";

export const FestiveLights = () => {
  const [lights, setLights] = useState<Array<{ id: number; color: string; delay: number; left: string }>>([]);

  useEffect(() => {
    const colors = [
      "hsl(350, 85%, 55%)", // red
      "hsl(145, 60%, 50%)", // green
      "hsl(45, 95%, 60%)", // gold
      "hsl(210, 100%, 70%)", // blue
      "hsl(280, 70%, 60%)", // purple
    ];

    const generatedLights = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      color: colors[Math.floor(Math.random() * colors.length)],
      delay: Math.random() * 3,
      left: `${(i / 29) * 100}%`,
    }));

    setLights(generatedLights);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 pointer-events-none h-20">
      {/* String/wire with sagging effect */}
      <svg className="absolute top-0 w-full h-20" viewBox="0 0 1000 80" preserveAspectRatio="none">
        <path
          d="M0,10 Q250,35 500,10 T1000,10"
          stroke="hsl(var(--muted-foreground))"
          strokeWidth="2"
          fill="none"
          opacity="0.4"
        />
      </svg>

      {/* Lights */}
      {lights.map((light, index) => {
        const yOffset = Math.sin((index / 29) * Math.PI * 2) * 25 + 10;
        return (
          <div
            key={light.id}
            className="absolute"
            style={{
              left: light.left,
              top: `${yOffset}px`,
              animation: `twinkle 2s ease-in-out infinite`,
              animationDelay: `${light.delay}s`,
            }}
          >
            {/* Wire connecting to bulb */}
            <div className="w-px h-3 bg-muted-foreground/30 mx-auto" />
            
            {/* Light bulb */}
            <div className="relative">
              {/* Outer glow */}
              <div
                className="absolute -inset-4 rounded-full blur-xl opacity-50"
                style={{ 
                  backgroundColor: light.color,
                  boxShadow: `0 0 20px ${light.color}`,
                }}
              />
              {/* Middle glow */}
              <div
                className="absolute -inset-2 rounded-full blur-md opacity-70"
                style={{ backgroundColor: light.color }}
              />
              {/* Bulb body - teardrop shape */}
              <div className="relative">
                <div
                  className="relative w-4 h-5 rounded-full"
                  style={{ 
                    backgroundColor: light.color,
                    boxShadow: `inset -1px -1px 2px rgba(0,0,0,0.2), inset 1px 1px 2px rgba(255,255,255,0.3)`,
                  }}
                />
                {/* Highlight */}
                <div 
                  className="absolute top-1 left-1 w-1.5 h-1.5 rounded-full bg-white/60"
                />
              </div>
              {/* Socket/cap */}
              <div className="w-3 h-1.5 mx-auto bg-muted-foreground/50 rounded-sm" 
                style={{ boxShadow: 'inset 0 1px 1px rgba(0,0,0,0.3)' }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
